/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/ArrowShape',['underscore', './Shape', 'fabric'], function (_, Shape) {
	'use strict';

	/**
  * New Arrow object based on the Line API.
  */

	window.fabric.Arrow = window.fabric.util.createClass(window.fabric.Line, {

		type: 'arrow',

		_render: function _render(ctx) {
			var p = this.calcLinePoints(),
			    size = 12,
			    width = 2,
			    dx = p.x2 - p.x1,
			    dy = p.y2 - p.y1,
			    hyp = Math.sqrt(dx * dx + dy * dy),
			    len = hyp - size,
			    head = len - size / 2,
			    angle = Math.atan2(dy, dx);

			ctx.save();
			ctx.translate(p.x1, p.y1);
			ctx.rotate(angle);

			ctx.beginPath();
			ctx.moveTo(0, -width);
			ctx.lineTo(len, -width);
			ctx.lineTo(head, -size);
			ctx.lineTo(hyp, 0);
			ctx.lineTo(head, size);
			ctx.lineTo(len, width);
			ctx.lineTo(0, width);
			ctx.closePath();
			this._renderPaintInOrder(ctx);

			ctx.restore();
		}
	});

	/**
  * Add static method for deserializing the Arrow object.
  */
	window.fabric.Arrow.fromObject = function (object, callback) {
		function _callback(instance) {
			delete instance.points;
			callback && callback(instance);
		}
		var options = _.extend({}, object, true);
		options.points = [object.x1, object.y1, object.x2, object.y2];
		window.fabric.Object._fromObject('Arrow', options, _callback, 'points');
	};

	var ArrowShape = Shape.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			ArrowShape.inherited('init', this, arguments);

			this.originalX = options.xCoord;
			this.originalY = options.yCoord;
			this.shape = new window.fabric.Arrow([options.xCoord, options.yCoord, options.xCoord, options.yCoord], _.extend({}, this.defaultAttributes, {
				fill: options.borderColor,
				figure: 'arrow',
				strokeWidth: 0
			}));
			options.canvas.add(this.shape);
		},

		resize: function resize(xCoord, yCoord) {

			this.shape.set({
				x2: xCoord,
				y2: yCoord,
				width: this.originalX - xCoord === 0 ? this.defaultWidth : Math.abs(this.originalX - xCoord),
				height: this.originalY - yCoord === 0 ? this.defaultHeight : Math.abs(this.originalY - yCoord)
			});

			return this.shape;
		}
	});

	ArrowShape.drawControlsVisibility = function (canvas, shape) {
		shape.setControlsVisibility({
			mtr: true,
			mb: true,
			mt: true,
			ml: true,
			mr: true,
			tl: true,
			br: true,
			tr: true,
			bl: true
		});
	};

	ArrowShape.scale = function (shape) {
		var scaleX = shape.scaleX,
		    scaleY = shape.scaleY;

		shape.set({
			width: shape.width * scaleX,
			height: shape.height * scaleY
		});
		shape.scale(1);
	};

	ArrowShape.canUpdate = function () {
		return true;
	};

	ArrowShape.canSkew = function () {
		return false;
	};

	ArrowShape.handleEnterKeyEvent = function (shape) {}; // eslint-disable-line no-unused-vars

	return ArrowShape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

